/**
 * @fileoverview gRPC-Web generated client stub for proto.services
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as proto_services_benchmark_service_pb from '../../proto/services/benchmark_service_pb';


export class BenchmarkServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoCreateBenchmark = new grpcWeb.MethodDescriptor(
    '/proto.services.BenchmarkService/CreateBenchmark',
    grpcWeb.MethodType.UNARY,
    proto_services_benchmark_service_pb.CreateBenchmarkRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_benchmark_service_pb.CreateBenchmarkRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  createBenchmark(
    request: proto_services_benchmark_service_pb.CreateBenchmarkRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  createBenchmark(
    request: proto_services_benchmark_service_pb.CreateBenchmarkRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  createBenchmark(
    request: proto_services_benchmark_service_pb.CreateBenchmarkRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.BenchmarkService/CreateBenchmark',
        request,
        metadata || {},
        this.methodInfoCreateBenchmark,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.BenchmarkService/CreateBenchmark',
    request,
    metadata || {},
    this.methodInfoCreateBenchmark);
  }

  methodInfoGetBenchmarks = new grpcWeb.MethodDescriptor(
    '/proto.services.BenchmarkService/GetBenchmarks',
    grpcWeb.MethodType.UNARY,
    proto_services_benchmark_service_pb.GetBenchmarksRequest,
    proto_services_benchmark_service_pb.GetBenchmarksResponse,
    (request: proto_services_benchmark_service_pb.GetBenchmarksRequest) => {
      return request.serializeBinary();
    },
    proto_services_benchmark_service_pb.GetBenchmarksResponse.deserializeBinary
  );

  getBenchmarks(
    request: proto_services_benchmark_service_pb.GetBenchmarksRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_benchmark_service_pb.GetBenchmarksResponse>;

  getBenchmarks(
    request: proto_services_benchmark_service_pb.GetBenchmarksRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_benchmark_service_pb.GetBenchmarksResponse) => void): grpcWeb.ClientReadableStream<proto_services_benchmark_service_pb.GetBenchmarksResponse>;

  getBenchmarks(
    request: proto_services_benchmark_service_pb.GetBenchmarksRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_benchmark_service_pb.GetBenchmarksResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.BenchmarkService/GetBenchmarks',
        request,
        metadata || {},
        this.methodInfoGetBenchmarks,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.BenchmarkService/GetBenchmarks',
    request,
    metadata || {},
    this.methodInfoGetBenchmarks);
  }

}

